<template>
  <div class="tag-field">
    <Tag
      v-for="item in currentValue"
      :key="item"
      :name="item"
      closable
      @on-close="remove(item)"
      >{{ item }}</Tag
    >
    <i-button
      icon="ios-plus-empty"
      type="dashed"
      size="small"
      @click="start"
      v-show="!editting"
    >
      New Tag
    </i-button>
    <input
      ref="input"
      type="text"
      v-model="newtag"
      @keyup.enter="add"
      @keyup.esc="cancel"
      placeholder="+ new tag"
      @blur="stop"
      v-show="editting"
    />
  </div>
</template>

<script>
import _ from "lodash";

export default {
  props: {
    value: { type: Array, default: () => [] },
  },
  data() {
    return {
      currentValue: this.value || [],
      newtag: "",
      editting: false,
    };
  },
  watch: {
    value(newValue) {
      this.currentValue = _.uniq(newValue) || [];
    },
  },
  methods: {
    start() {
      this.editting = true;
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },
    stop() {
      this.newtag = "";
      this.editting = false;
    },
    add() {
      if (!_.includes(this.currentValue, this.newtag)) {
        this.currentValue.push(this.newtag);
        this.updateValue(this.currentValue);
      }
      this.newtag = "";
    },
    remove(item) {
      this.currentValue = this.currentValue.filter(value => value !== item);
      this.updateValue(this.currentValue);
    },
    cancel() {
      this.newtag = "";
    },
    updateValue(newValue) {
      this.currentValue = _.uniq(newValue);
      this.$emit("input", this.currentValue);
    },
  },
};
</script>

<style scoped>
input {
  border: 1px dashed #eee;
  padding: 4px 6px;
  margin: 0px;
  line-height: 1em;
}
.tag-field {
  border: 1px solid #dddee1;
  padding: 0px 6px;
  border-radius: 4px;
}
</style>
